import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-something-went-wrong',
  templateUrl: './something-went-wrong.component.html',
  styleUrls: ['./something-went-wrong.component.scss']
})
export class SomethingWentWrongComponent {
  constructor(private router: Router) { }

  goBack() {
    const lastUrl = sessionStorage.getItem('lastUrl');
    if (lastUrl) {
      this.router.navigateByUrl(lastUrl);
    } else {
      this.router.navigate(['/']); // fallback
    }
  }

}
